import zustand from 'zustand'

const loadLocaleData = (locale: string) => {
  switch (locale) {
    case 'de':
      return import('../../lang/de.json')
    case 'da':
      return import('../../lang/da.json')
    default:
      return import('../../lang/en.json')
  }
}

type State = {
  locale: string
  defaultLocale: string
  loadMessages: () => PromiseLike<any>
  updateLocale: (locale: string | undefined) => void
}

const useLocale = zustand<State>((set, get) => ({
  locale: 'en',
  defaultLocale: 'en',
  loadMessages: async () => {
    const { locale } = get()
    const data = await loadLocaleData(locale)
    return data
  },
  updateLocale: (locale) => {
    if (locale !== undefined) {
      const selectedLocale =
        Object({
          en_US: 'en',
          da_DK: 'da',
          de_DE: 'de',
        })[locale] || 'en'
      set({ locale: selectedLocale })
    }
  },
}))

export default useLocale
